<template>
  <div v-if="forma" class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">Detalhes da Forma de Pagamento</h4>
      <router-link to="/financeiro/parametros/formas">
        <button class="btn btn-secondary btn-sm">Voltar</button>
      </router-link>
    </div>

    <div class="form-content mt-3">
      <FormSection title="">
        <p><strong>Operador:</strong> {{ forma.nome_operador || 'Não informado' }}</p>
        <p><strong>Meio:</strong> {{ forma.nome_meio || 'Não informado' }}</p>
        <p><strong>Forma:</strong> {{ forma.forma || 'Não informado' }}</p>
        <p><strong>Criado em:</strong> {{ formatDate(forma.criado_em) }}</p>
        <p><strong>Atualizado em:</strong> {{ formatDate(forma.atualizado_em) }}</p>
      </FormSection>
    </div>
  </div>

  <div v-else>
    <LoadingSpinner />
  </div>
</template>

<script>
import axios from "@/services/axios";
import FormSection from "@/components/Layout/FormSection.vue";

export default {
  components: { FormSection },
  data() {
    return {
      forma: null,
    };
  },
  methods: {
    async carregarDetalhesForma() {
      try {
        const response = await axios.get(
          `/financeiro/parametros/formas/${this.$route.params.id}`
        );
        this.forma = response.data;
      } catch (error) {
        console.error("Erro ao carregar os detalhes da forma:", error);
      }
    },
    formatDate(data) {
      if (!data) return "Não informado";
      return new Date(data).toLocaleString();
    },
  },
  mounted() {
    this.carregarDetalhesForma();
  },
};
</script>

<style scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0rem;
}
.form-header h4 {
  margin: 0;
  font-weight: bold;
  text-align: left;
}
.form-content {
  margin-top: 1.5rem;
}
button.btn-sm {
  padding: 6px 12px;
}
</style>
